// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__Kt+Pb","closed":"styles_closed__jZjJP","socialIcons":"styles_socialIcons__QlWdg"};